/*
* vue-cli3 一直运行 /sockjs-node/info?t=
* sockjs-node 是一个JavaScript库，提供跨浏览器JavaScript的API，创建了一个低延迟、全双工的浏览器和web服务器之间通信通道。
*
* 1. 找到/node_modules/sockjs-client/dist/sockjs.js
* 2.找到代码的 1605行
* try {
  //  self.xhr.send(payload); 把这里注掉
  } catch (e) {
    self.emit('finish', 0, '');
    self._cleanup(false);
  }
* */

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { ApiUrl } from "../utils/config.js";
import { VERSION } from "@/utils/vuever";

// 这里写的是axios请求的时候的配置
let _axios = axios.create({
    baseURL: ApiUrl,
    timeout: 10000,
    withCredentials: true, // 设置默认请求带cookie
    crossDomain: true
});


// 请求拦截器
_axios.interceptors.request.use(
    config => {
        if (config.method === 'get') {
            config.params = {
                ...config.params,
                t: new Date().getTime(),
                vue_ver: VERSION
            };
        }
        config.params.VUE_TYPE = "web";
        return config;
    },

);


// 响应拦截器
_axios.interceptors.response.use(
    response => {
        return Promise.resolve(response);
    },
    error => {
        if (axios.isCancel(error)) {
            return Promise.reject(error);
        }
        if (error.response.status == 303) {
            let url = window.location.href;
            let version = new Date().getTime();
            if (url.indexOf('?', 0) > -1) {
                location.replace(url + '&vue_ver=' + version);
            } else {
                location.replace(url + '?vue_ver=' + version);
            }
            return Promise.reject(error);
        }
    }
)

// Vue.use(VueAxios, axios)   // 因为自定义了请求配置，用下面的写法
Vue.use(VueAxios, _axios)

// 友情链接
_axios.friendLink = (params) => {
    return Vue.axios.get('website/friendLink', {
        params: params,
        keep_cache: 0
    })
}

// 统计
_axios.statsClick = (params) => {
    return Vue.axios.get('website/statsClick', {
        params: params,
        keep_cache: 0
    })
}

// 新闻资讯列表 1 新闻，2官方
_axios.news = (params) => {
    return Vue.axios.get('website/news', {
        params: params,
        keep_cache: 0
    })
}

// 新闻资讯详情
_axios.newsDetail = (params) => {
    return Vue.axios.get('website/newsDetail', {
        params: params,
        keep_cache: 0
    })
}

// 下载地址
_axios.install = () => {
    return Vue.axios.get('other/install', {
        params: {
            channel: 2,
        }
    })
}

// 口令获取接口
_axios.passCodeCreate = () => {
    return Vue.axios.get('web/passCodeCreate')
}

// 隐私协议
_axios.getPrivacy = (params) => {
    return Vue.axios.get('website/privacy', {
        params: params,
        keep_cache: 0
    })
}
